import pl from "@locales/calendar_entries/pl.json";
import en from "@locales/calendar_entries/en.json";

export default { pl, en };
